import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyMagicToken } from "../lib/api";
import { useAuth } from "../lib/useAuth";

export default function Verify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState<"working" | "ok" | "error">("working");
  const [errorCode, setErrorCode] = useState<string | null>(null);

  const token = searchParams.get("token");
  const next = searchParams.get("next") ?? "/profile";

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setErrorCode("missing_token");
      return;
    }
    void (async () => {
      try {
        await verifyMagicToken(token);
        await refresh();
        setStatus("ok");
        setTimeout(() => navigate(next, { replace: true }), 600);
      } catch (e) {
        setStatus("error");
        setErrorCode((e as Error).message);
      }
    })();
  }, [token, refresh, navigate, next]);

  return (
    <div className="max-w-prose space-y-4">
      {status === "working" && (
        <>
          <h1 className="text-3xl font-semibold">Verifying…</h1>
          <p className="text-muted">Hold on.</p>
        </>
      )}
      {status === "ok" && (
        <>
          <h1 className="text-3xl font-semibold">Welcome.</h1>
          <p className="text-muted">Redirecting…</p>
        </>
      )}
      {status === "error" && (
        <>
          <h1 className="text-3xl font-semibold">That link didn't work.</h1>
          <p>
            {errorCode === "invalid_or_expired_token"
              ? "The link is invalid or expired. Magic links last 15 minutes and can only be used once."
              : `Error: ${errorCode ?? "unknown"}`}
          </p>
          <p>
            <a href="/register">Request a new one</a>.
          </p>
        </>
      )}
    </div>
  );
}
